export class FrequencyFormattingConstants {
    public static readonly frequencyDecimalPlaces = 5;
}
